

















import PartnerRowTable from '@/views/organisms/PartnerRowTable.vue'

export default
  components: {
    PartnerRowTable
  }

  props:
    row:
      type: Object
  methods: {
    getList: (e) ->
      @$emit('click')
  }
